import { Countries, Regions } from 'src/graphql/schema.graphql';
import { gql, GqlFragment } from 'src/utils/gql/query';

export const speakersRegionsGqlQuery: GqlFragment<{
  countries: Countries[];
  regions: Regions[];
}> = gql`
  query {
    regions {
      slug
      translations {
        name
        languages_code {
          code
        }
      }
    }
    countries(filter: { people_func: { count: { _gt: 0 } } }, limit: -1) {
      slug
      regions {
        regions_id {
          slug
        }
      }
      translations {
        name
        languages_code {
          code
        }
      }
    }
  }
`;
